var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachment = function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 18.125a3.756 3.756 0 0 1-3.75-3.75V4.733a2.863 2.863 0 0 1 4.883-2.025c.542.534.842 1.259.842 2.025v8.15c0 1.05-.858 1.909-1.908 1.909a1.913 1.913 0 0 1-1.909-1.909V6.542a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v6.341c0 .367.292.659.659.659a.654.654 0 0 0 .658-.659v-8.15c0-.433-.167-.833-.475-1.141A1.61 1.61 0 0 0 7.4 4.725v9.642c0 1.375 1.125 2.5 2.5 2.5s2.5-1.125 2.5-2.5V6.55a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v7.825a3.756 3.756 0 0 1-3.75 3.75Z",
    fill: "current"
  })));
};
export default SvgAttachment;